import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.planning')
  .factory('$draftRoutes', planningDraftRoutesObjectFactory);

/* @ngInject */
    function planningDraftRoutesObjectFactory($bringozFactory: $bringozFactory,
                                              PlanningDraftRoutesAPI: BringozApi,
                                              Planning_Draft_Routes_DS: DataStoreConfig,
                                              Draft_Routes_PN: PushNotificationsConfig) {

        function $draftRoutes(id: string) {
            return $bringozFactory(id, PlanningDraftRoutesAPI, Planning_Draft_Routes_DS, Draft_Routes_PN)
        }
        return $draftRoutes
    }
